// features/client/client.fields.js

export const fieldsConfig = [
  // 🔹 Personal Information
  {
    name: "first_name",
    label: "First Name",
    type: "text",
    required: true,
  },
  {
    name: "last_name",
    label: "Last Name",
    type: "text",
    required: false
  },
  {
    name: "gender",
    label: "Gender",
    type: "select",
    // required: true,
    is_enums_data: true,
    enums: ["MALE", "FEMALE"],
  },
  {
    name: "profile_picture_url",
    label: "Profile Image",
    type: "file",
    required: false,
    maxSizeMB: 10,        // max allowed size
    convertSizeKB: 20,   // final compressed target size
    acceptedTypes: ["image/jpeg", "image/png", "image/webp"]
  },
  {
    name: "user_role_fid",
    label: "User Role",
    type: "select",
    required: false,
    optionsKey: "userRoles",
    optionLabel: "role",
    isReadOnly: true,
    defaultOptionValue: "ADMIN",
    is_api_data: true,
  },

  // 🔹 Contact Information
  {
    name: "email",
    label: "Email",
    type: "email",
    required: true
  },
  {
    name: "phone",
    label: "Phone",
    type: "text",
    required: false
  },
  {
    name: "city",
    label: "City",
    type: "text",
    required: false
  },
  {
    name: "country_directory_fid",
    label: "Country",
    type: "select",
    required: true,
    optionsKey: "countries",
    optionLabel: "country_name",
    is_api_data: true,
  },
  {
    name: "location",
    label: "Location",
    type: "text",
    required: false
  },

  // 🔹 Professional Information
  {
    name: "company_fid",
    label: "Company",
    type: "select",
    required: true,
    optionsKey: "companies",
    optionLabel: "company_name",
    is_api_data: true,
  },
  {
    name: "designation_fid",
    label: "Designation",
    type: "select",
    required: false,
    optionsKey: "designations",
    optionLabel: "designation_name",
    is_api_data: true,
  },
  {
    name: "is_notify",
    label: "Send Email Notification",
    type: "boolean",
    uiType: "checkbox",
    defaultValue: true,
    wrapperClassName: "flex gap-2  justify-start items-center"
  }


];